import NoDataComponent from "./../../../Table/TableComponents/NoDataComponent";
import React from "react";
import { MdPeople } from "react-icons/md";

const worker_housing_no_data = props => {
  return (
    <NoDataComponent
      {...props}
      icon={<MdPeople size={60} className="noDataIcon" />}
      headerinfo="No Worker Housing"
      subheaderinfo="Worker Housing will appear here"
    />
  );
};

export default worker_housing_no_data;